module.exports = __webpack_public_path__ + "img/steam.3330bdbb.png";